import { all, takeLatest, call, put, delay, select } from 'redux-saga/effects';
import { resolverActions } from '$store/resolver/index';
import { ResolveAction } from '$store/resolver/interface';
import { Api } from '$api';
import { handleProfileResult } from '$store/profile/sagas';
import { handleGroupInfo } from '$store/groups/sagas';
import { getStorageItem, removeStorageItem, sendRef, setStorageItem } from '$utils';

function* resolveWorker(action: ResolveAction) {
  const { mode, domain } = action.payload;

  try {
    const data = yield call(Api.post, '/resolve', {
      mode,
      domain,
    });

    if (data.type === 'user') {
      yield call(handleProfileResult, data.id, data.info);
      if ((yield call(getStorageItem, 'refDomain')) === domain) {
        const hexId = Number(data.id).toString(16);
        yield call(sendRef, hexId);
        yield call(setStorageItem, 'ref', hexId);
        yield call(removeStorageItem, 'refDomain');
      }
    } else if (data.type === 'group') {
      yield call(handleGroupInfo, data.id, data.info);
    }

    yield delay(10);
    yield put(
      resolverActions.setResult({
        mode,
        domain,
        result: data,
      }),
    );
  } catch (e) {
    if (e.code === 'not_found') {
      yield put(resolverActions.setNotFound({ mode, domain }));
    } else if (e.code === 'profile_country_blocked') {
      yield put(resolverActions.setGeoBlocked({ mode, domain }));
    } else {
      yield put(resolverActions.setFailed({ mode, domain }));
    }
  }
}

export function* resolverSaga() {
  yield all([takeLatest(resolverActions.resolve, resolveWorker)]);
}
